import { Input, TextField } from '@shared/ui/kit';
import { Modal } from '@shared/ui/modal';
import { ChangeEvent, useEffect, useState } from 'react';
import styles from './EditParticipantTextModal.module.scss';

interface EditParticipantTextModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  title: string;
  participantName: string;
  value: string;
  placeholder?: string;
  fieldLabel?: string;
}

export const EditParticipantTextModal = ({
  isOpen,
  onClose,
  onSave,
  title,
  participantName,
  value,
  placeholder = 'Введите текст',
  fieldLabel,
}: EditParticipantTextModalProps) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    if (!isOpen) return;
    setDraft(value);
  }, [isOpen, value]);

  const handleSave = () => {
    onSave(draft);
    onClose();
  };

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setDraft(e.target.value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width={528}
      className={styles.modal}
      cancelButton={{
        text: 'Отмена',
        onClick: onClose,
        settings: { width: '106px', minWidth: '106px' },
      }}
      applyButton={{
        text: 'Сохранить',
        onClick: handleSave,
        settings: { width: '112px', minWidth: '112px' },
      }}
    >
      <div className={styles.content}>
        <Input value={participantName} labelText="ФИО клиента" readonly settings={{ width: '100%' }} />

        <div className={styles.textarea}>
          <TextField
            value={draft}
            changeFunction={handleChange}
            placeholder={placeholder}
            labelMsg={fieldLabel}
            settings={{
              width: '100%',
              resize: 'none',
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
